// The assembled provider registry — 41 connectors across 8 family files.
//
// Order matters: it is the order the Connections page renders a category's connectors in, and it
// is v3's `INTEGRATIONS_CONFIGS` order regrouped by family rather than re-sorted. Google and
// BigQuery lead because they did in v3; the rest follow their v3 relative order.

import type { IntegrationProvider } from '../providers.types'

import { CREDENTIAL_PROVIDERS } from './credential'
import { DATABASE_PROVIDERS } from './database'
import { ECOMMERCE_PROVIDERS } from './ecommerce'
import { GOOGLE_PROVIDERS } from './google'
import { META_PROVIDERS } from './meta'
import { MMP_PROVIDERS } from './mmp'
import { SOCIAL_PROVIDERS } from './social'
import { TIKTOK_PROVIDERS } from './tiktok'

export const INTEGRATION_PROVIDERS: readonly IntegrationProvider[] = [
  ...META_PROVIDERS,
  ...TIKTOK_PROVIDERS,
  ...GOOGLE_PROVIDERS,
  ...DATABASE_PROVIDERS,
  ...SOCIAL_PROVIDERS,
  ...MMP_PROVIDERS,
  ...ECOMMERCE_PROVIDERS,
  ...CREDENTIAL_PROVIDERS,
]

export {
  CREDENTIAL_PROVIDERS,
  DATABASE_PROVIDERS,
  ECOMMERCE_PROVIDERS,
  GOOGLE_PROVIDERS,
  META_PROVIDERS,
  MMP_PROVIDERS,
  SOCIAL_PROVIDERS,
  TIKTOK_PROVIDERS,
}

const BY_KEY = new Map(INTEGRATION_PROVIDERS.map((provider) => [provider.key, provider]))

/** The provider behind a registry key. Prefer this over `id` — `id` is not unique. */
export function resolveProvider(key: string): IntegrationProvider | null {
  return BY_KEY.get(key) ?? null
}

/**
 * Every provider sharing a `workspaceIntegration` id.
 *
 * Returns four entries for `bigquery_account` and one for everything else, which is why callers
 * that hold only a wire id (a permission string, a report's channel) must handle a list.
 */
export function providersById(id: string): readonly IntegrationProvider[] {
  return INTEGRATION_PROVIDERS.filter((provider) => provider.id === id)
}
